import { getPreciseDistance } from "geolib";

const options = {
  timeout: 30000, // タイムアウト時間30秒
  enableHighAccuracy: true, // 精度の高い位置情報を取得
  maximumAge: 0, // 常に最新の位置情報を取得
};

// geolocationAPIのラッパー関数の為、テストから除外
/* istanbul ignore next */
export const getCurrentPosition = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

export const isNear = (currentPos, settingPos) => {
  const threshold = 100;
  const distance = calcDistance(currentPos, settingPos);

  return distance <= threshold;
};

// getPreciseDistance()のラッパー関数の為、テストから除外
/* istanbul ignore next */
export const calcDistance = (currentPos, settingPos) => {
  return getPreciseDistance(currentPos, settingPos);
};
